import type {Prompt} from '@cp/model';
import {createCallable} from './createCallable';

export const promptsGenerateQuestion = createCallable<{moduleId: string; topic: string; difficulty: number}, Prompt>(
  'promptsGenerateQuestion',
);

export const promptsGenerateQuestionGraphJson = createCallable<
  {
    questionText: string;
    topic?: string;
    difficulty?: number;
    hint?: string;
    options?: string[];
    answer?: string;
    explanation?: string;
  },
  Prompt
>('promptsGenerateQuestionGraphJson');

export const promptsGenerateStudy = createCallable<{moduleId: string; topic: string; additionalInfo?: string}, Prompt>(
  'promptsGenerateStudy',
);

export const promptsGetPdfSystem = createCallable<{additionalInfo?: string}, Prompt>('promptsGetPdfSystem');

export const promptsGetPdfExtractQuestion = createCallable<{additionalInfo?: string}, Prompt>(
  'promptsGetPdfExtractQuestion',
);

export const promptsGenerateQuestionWithSeed = createCallable<
  {moduleId: string; seedQuestionId: string; numberOfVariants: number},
  Prompt
>('promptsGenerateQuestionWithSeed');
